import { render } from "./FormCarro.vue?vue&type=template&id=3acdf86c"
import script from "./FormCarro.vue?vue&type=script&lang=js"
export * from "./FormCarro.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__